import React, { useEffect, useContext } from 'react';
import { Field, WrappedFieldProps } from 'redux-form';
import { connect } from 'react-redux';
import { trim, debounce, get } from 'lodash';
import Dropzone from '@omilia/dropzone';

// @ts-ignore
import { importProject } from 'store/services/projects/actions';
import TextFieldReduxWrapper from 'components/TextFieldReduxWrapper';
import { SAutoCompleteMenuWrapper } from 'components/styled';
import FORM_NAMES from 'constants/formNames';
import FormWrapper, {
  FormContext,
} from 'scenes/Projects/scenes/CreateProjectModal/components/FormWrapper';
import {
  ImportProjectProps,
  FormValuesType,
  AccountTypeForm,
} from 'scenes/Projects/types';

import { importProjectValidate } from '../utils/validate';

const renderAutocomplete = (props: WrappedFieldProps) => (
  <SAutoCompleteMenuWrapper {...props} />
);

const ImportProject = ({
  accounts,
  getAccounts,
  isLoadingAccounts,
  importProject,
  cancelGetAccounts,
  onSetProjectType,
  onCloseRequest,
}: ImportProjectProps) => {
  const { onChange, formValues } = useContext(FormContext);
  const debouncedGetAccounts = debounce(getAccounts, 400);

  useEffect(() => {
    onSetProjectType('import-project');
  }, [onSetProjectType]);

  const getAccountsCancelingPreviousRequest = (value = '') => {
    cancelGetAccounts();
    debouncedGetAccounts(value);
  };

  const handleSelectAccountItem = (item: AccountTypeForm) =>
    onChange('account', item);

  const handleSubmit = async ({ name, account, files }: FormValuesType) => {
    await importProject({
      name,
      account: account.slug,
      nlu_file: files && files[0],
    });

    onCloseRequest();
  };

  return (
    <FormWrapper
      form={FORM_NAMES.PROJECT.IMPORT}
      submitBtnName="Import"
      validate={importProjectValidate}
      onCloseRequest={onCloseRequest}
      onSubmitForm={handleSubmit}
    >
      <Field
        autoFocus
        component={TextFieldReduxWrapper}
        data-test="name"
        label="Project Name"
        name="name"
        normalize={trim}
        placeholder="Please type a name for the project"
        type="text"
      />

      <Field
        component={renderAutocomplete}
        data-test="account"
        isLoading={isLoadingAccounts}
        item={get(formValues, 'account.name', '')}
        items={accounts}
        label="Select Organization"
        name="account"
        placeholder="Select Organization"
        selectItem={handleSelectAccountItem}
        onChangeValue={getAccountsCancelingPreviousRequest}
        onOpen={getAccountsCancelingPreviousRequest}
      />

      <Field
        component={field => (
          <Dropzone
            accept=".nlu"
            description="Drop .nlu file here to import"
            error={field.meta.touched && field.meta.invalid && field.meta.error}
            label="Drag and drop files here"
            multiple={false}
            onChange={filesToUpload => field.input.onChange(filesToUpload)}
          />
        )}
        name="files"
      />
    </FormWrapper>
  );
};

export const mapDispatchToProps = {
  importProject,
};

export default connect(
  null,
  mapDispatchToProps,
)(ImportProject);
